import React from 'react';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';

import './style.css';

class GoogleAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: '' };
  }

  handleOnChangeReduxForm = (address) => {
    const { input, meta } = this.props;

    if(meta && input) {
      input.onChange(address);
    }
  }

  onChange = (address, ...rest) => {
    const { handleGoogleAddress } = this.props;

    this.setState({ address });

    this.handleOnChangeReduxForm(address);
    handleGoogleAddress(address, ...rest);
  }

  handleSelect = async (address) => {
    try {
      const results = await geocodeByAddress(address);
      const lat = results[0].geometry.location.lat();
      const lng = results[0].geometry.location.lng();
      const formatedAddress = results[0].formatted_address;
      this.onChange(formatedAddress, lat, lng);
    } catch (error) {
      if(error==="ZERO_RESULTS")
        {
          this.onChange(address);
        }
    }
}


  render() {
    const { placeholder, meta } = this.props;
    const errorMessage = meta && meta.touched && meta.error;

    const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
      onBlur: () => { this.handleSelect(this.state.address)},
      placeholder: placeholder,
      "data-testid": "google-address-input",
    };

    return (
      <div className={`${errorMessage ? "error" : ""} field`}>
        <PlacesAutocomplete inputProps={inputProps} onSelect={this.handleSelect} />
        {errorMessage && (
          <span className="error-message">{errorMessage}</span>
        )}
      </div>
    );
  }
}

export default GoogleAddress;



// WEBPACK FOOTER //
// ./src/components/GoogleAddress/GoogleAddress.js